import Row from '@sdk/components/ui/spacing/Row';
import DisplayText from '@sdk/components/ui/DisplayText';
import Clickable from '@sdk/components/primitives/Clickable';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import gettext, { ngettext } from '@sdk/lang/gettext';

import LocationIconSvg from '@web/assets/svg/UI/location-gray.svg';
import DropdownSvg from '@web/assets/svg/UI/dropdown-gray.svg';
import {
  ChecklistHeaderRow,
  LocationCounterRow,
} from '@web/shifts/LocationChecklist/LocationChecklist.styles';

import { LocationChecklistFlag } from './types';

type Props = {
  userLocations: LocationChecklistFlag[];
  onClick: () => void;
  checkedLocationsCount: number;
};

const LocationChecklistHeader: React.FC<React.PropsWithChildren<Props>> = ({
  userLocations,
  onClick,
  checkedLocationsCount,
}) => {
  const allSelected = checkedLocationsCount === userLocations.length;
  return (
    <Clickable onClick={onClick}>
      <ChecklistHeaderRow>
        <Row mLeft={10}>
          <LocationIconSvg />
        </Row>
        <LocationCounterRow mRight={50}>
          <DisplayText themeColor={ThemeColorType.gray} semiBold fontSize={12}>
            {allSelected
              ? gettext('All locations')
              : ngettext('%(count)s location', '%(count)s locations', checkedLocationsCount, {
                  count: checkedLocationsCount,
                })}
          </DisplayText>
        </LocationCounterRow>
        <Row>
          <DropdownSvg />
        </Row>
      </ChecklistHeaderRow>
    </Clickable>
  );
};

export default LocationChecklistHeader;
